export default function getGroupKey<T extends Record<string, unknown>>(
	primaryProp: keyof T,
	secondaryProp: keyof T,
	item: T,
) {
	const primaryValue = `${item[primaryProp]}`;
	const secondaryValue = secondaryProp ? `${item[secondaryProp]}` : "";

	if (primaryValue === "Equity" || primaryValue === "Fixed Income") {
		return [`${secondaryValue} ${primaryValue}`, primaryValue, secondaryValue];
	}
	return [primaryValue];
}
